import {
  RESET_STATE,
  CHANGE_DIRECTION,
  CHANGE_NAVIGATION_STYLE,
  FIXED_DRAWER,
  HORIZONTAL_MENU_POSITION,
  INSIDE_THE_HEADER,
  SWITCH_LANGUAGE,
  TOGGLE_COLLAPSED_NAV,
  VERTICAL_NAVIGATION,
  WINDOW_WIDTH,
  THEME_COLOR
} from "constants/ActionTypes";

import { DARK_DEEP_ORANGE } from "../constants/ThemeColors";
import { getUserServer } from "../util/localStorageService";
import { APP_DEFAULTS, USER_SERVER } from "../util/Utility";

const rltLocale = ["ar"];
const BRAND_THEME_COLOR = DARK_DEEP_ORANGE;
const THEME_COLOR_CLASSES = [
  "indigo",
  "cyan",
  "amber",
  "deep-orange",
  "pink",
  "blue",
  "deep-purple",
  "green",
  "dark-indigo",
  "dark-cyan",
  "dark-amber",
  "dark-deep-orange",
  "dark-pink",
  "dark-blue",
  "dark-deep-purple",
  "dark-green"
];
const initialSettings = {
  navCollapsed: false,
  drawerType: FIXED_DRAWER,
  width: window.innerWidth,
  isDirectionRTL: false,
  navigationStyle: VERTICAL_NAVIGATION,
  horizontalNavPosition: INSIDE_THE_HEADER,
  locale: {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us"
  },
  themeColor: getThemeColor(),
  env: getEnv() || APP_DEFAULTS.DEVELOPMENT
};

function getThemeColor() {
  const body = document.body.classList;
  THEME_COLOR_CLASSES.forEach(themeClass => body.remove(themeClass));
  body.remove("dark-theme");
  body.add(BRAND_THEME_COLOR);
  return BRAND_THEME_COLOR;
}

function getEnv() {
  const userServer = getUserServer();

  switch (userServer) {
    case USER_SERVER.PROD:
      return APP_DEFAULTS.PRODUCTION;
    case USER_SERVER.DEV:
    case USER_SERVER.LOCAL:
    case USER_SERVER.DEVALPHA:
      return APP_DEFAULTS.DEVELOPMENT;
    case USER_SERVER.STG:
    default:
      return APP_DEFAULTS.STAGING;
  }
}

const settings = (state = initialSettings, action) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        navCollapsed: false
      };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.isNavCollapsed
      };
    case WINDOW_WIDTH:
      return {
        ...state,
        width: action.width
      };
    case SWITCH_LANGUAGE:
      return {
        ...state,
        locale: action.payload,
        isDirectionRTL: rltLocale.includes(action.payload.locale)
      };
    case CHANGE_DIRECTION:
      return {
        ...state,
        isDirectionRTL: !state.isDirectionRTL
      };

    case CHANGE_NAVIGATION_STYLE:
      return {
        ...state,
        navigationStyle: action.payload
      };

    case HORIZONTAL_MENU_POSITION:
      return {
        ...state,
        horizontalNavPosition: action.payload
      };

    case THEME_COLOR:
      return { ...state, themeColor: BRAND_THEME_COLOR, env: getEnv() };

    case RESET_STATE:
      return { ...initialSettings };

    default:
      return state;
  }
};

export default settings;
